import { IsNotEmpty, IsString, MaxLength } from 'class-validator';

export class CityCreateDto {
  @IsString()
  @IsNotEmpty()
  @MaxLength(100)
  name: string;

  @IsString()
  @IsNotEmpty()
  @MaxLength(2)
  countryCode: string;
}